import { render, staticRenderFns } from "./action-show.vue?vue&type=template&id=035e3f28&"
import script from "./action-show.vue?vue&type=script&lang=js&"
export * from "./action-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports